import { useDebounceFn } from '@vueuse/core'

let isMenuOpen = false
let nav: HTMLElement,
    container: HTMLElement,
    overlay: HTMLElement,
    button: HTMLElement

export default function useMobileMenu() {
    function updateNodes(): void {
        nav = document.getElementById('mobile-nav') as HTMLElement
        container = nav?.parentElement as HTMLElement
        overlay = document.getElementById('mobile-menu-overlay') as HTMLElement
        button = document.getElementById('mobile-menu-button') as HTMLElement

        if (!nav || !container || !overlay || !button) {
            throw Error('Mobile menu elements not found')
        }
    }

    function init() {
        updateNodes()

        container.style.removeProperty('--wrap-nav')

        const containerWidth = container.clientWidth - 80

        if (containerWidth < nav.clientWidth) {
            container.style.setProperty('--wrap-nav', 'true')
        }

        setTimeout(() => {
            nav.classList.add(
                'transition-transform',
                'duration-300',
                'ease-out'
            )
        }, 10)
    }

    function toggleMenu() {
        if (!isMenuOpen) {
            nav.classList.add('mobile-nav--open')
            overlay.classList.add('mobile-menu-overlay--open')
            button.setAttribute('aria-expanded', 'true')
            button.setAttribute('aria-label', 'Menü schließen')
            document.documentElement.style.overflow = 'hidden'
            button.focus()

            isMenuOpen = true
        } else {
            close()
        }
    }

    function close() {
        if (!isMenuOpen) return

        nav.classList.remove('mobile-nav--open')
        overlay.classList.remove('mobile-menu-overlay--open')
        button.setAttribute('aria-expanded', 'false')
        button.setAttribute('aria-label', 'Menü öffnen')
        document.documentElement.style.overflow = ''

        isMenuOpen = false
    }

    /* Register event listeners */
    window.addEventListener('resize', useDebounceFn(init))

    document.addEventListener('DOMContentLoaded', init)

    document.addEventListener('click', (e) => {
        const target = e.target as HTMLElement

        // Check if click is on burger button or its children
        if (target.closest('#mobile-menu-button')) {
            e.preventDefault()
            toggleMenu()
        }

        // Check if click is on overlay
        if (target.closest('#mobile-menu-overlay')) {
            toggleMenu()
        }
    })

    // Escape key handler
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && isMenuOpen) {
            toggleMenu()
            const button = document.getElementById('mobile-menu-button')
            button?.focus()
        }
    })

    return {
        init,
        close,
    }
}
